module.exports = __webpack_public_path__ + "img/ico_2.f69b61dd.png";